import moment from 'moment';
import { pathOr } from 'ramda';

import { QUOTE_ITEM_ID_PARAM } from './const';
import type {
  OrderByNumberParams,
  Order,
  OrderByNumberApiResponse,
} from './types';

export type GetOrderByNumberQueryKeyType = readonly [
  'orderByNumber',
  string,
  string,
];

export const getOrderByNumberQueryKey = (
  params: OrderByNumberParams,
): GetOrderByNumberQueryKeyType => [
  'orderByNumber',
  params.groupId,
  params.orderNumber,
];

export const getQuoteItemIdFromParams = (
  search: URLSearchParams,
): number | undefined => {
  const quoteItemId = search.get(QUOTE_ITEM_ID_PARAM);
  if (!quoteItemId) return undefined;

  const value = parseInt(quoteItemId, 10);
  return isNaN(value) ? undefined : value;
};

export const addQuoteItemIdToParams = (
  search: URLSearchParams,
  quoteItemId: number,
): URLSearchParams => {
  const newSearch = new URLSearchParams(search);
  newSearch.set(QUOTE_ITEM_ID_PARAM, quoteItemId.toString());
  return newSearch;
};

export const removeQuoteItemIdFromParams = (
  search: URLSearchParams,
): URLSearchParams => {
  const newSearch = new URLSearchParams(search);
  newSearch.delete(QUOTE_ITEM_ID_PARAM);
  return newSearch;
};

//TODO - would really like to avoid using this - would require a good amount of frontend or backend refactoring
export const transformOrderApiResponse = (
  data: OrderByNumberApiResponse,
): Order => {
  data.shipsOn = moment(data.shipsOn);
  data.deliverBy = data.deliverBy ? moment(data.deliverBy).utc() : undefined;
  data.purchaseOrderNumber = data.purchaseToken;
  data.quoteItems = data.orderItems
    ? data.orderItems.map((item) => ({
        ...item,
        ...item.quoteItem,
        rootComponent: {
          ...item.quoteItem.rootComponent,
          addOns: pathOr(
            [],
            ['quoteItem', 'rootComponent', 'addOns'],
            item,
          ).filter((addOn) =>
            pathOr([], ['orderedAddOns'], item).find(
              (orderedAddOn) => orderedAddOn.id === addOn.id,
            ),
          ),
          quantities: pathOr(
            [],
            ['quoteItem', 'rootComponent', 'quantities'],
            item,
          ).filter((compQuantity) => compQuantity.quantity === item.quantity),
        },
        shipsOn: moment(item.shipsOn),
        orderItemId: item.id,
      }))
    : [];
  data.shippingInfo = data.buyerShipping;
  data.billingInfo = data.buyerBilling;
  if (data.shippingOption) {
    data.shippingOption.grouping = data.shippingOption.shipWhen;
    data.shippingOption.customerAccount =
      data.shippingOption.customers_accountNumber;
    data.shippingOption.method = data.shippingOption.shippingMethod;
    data.shippingOption.customerCarrier = data.shippingOption.customersCarrier;
  }
  data.shipments &&
    data.shipments.forEach((item) => {
      item.shipmentDate = item.shipmentDate ? moment(item.shipmentDate) : null;
      item.paymentDueDate = item.paymentDueDate
        ? moment(item.paymentDueDate)
        : null;
    });

  // NB: This function in it's current state is effectively untypeable because of the massive mutation of the argument. At the time of migrating this
  // util from it's initial place the code base, it's too risky + time consuming to refactor. Therefore: this ugly coercion is a practical necessity.
  return data as unknown as Order;
};
